import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BaseHttpService } from '@shared/services-http/base-http.service';
import { ICreateUserAccountWorker, IRemoveUserAccountWorker } from '@src/app/interfaces/api/users-workers.interface';

@Injectable({
  providedIn: 'root'
})
export class UsersWorkersService extends BaseHttpService {

  constructor(
    private httpClient: HttpClient,
  ) {
    super();
  }

  public CreateUser(data: ICreateUserAccountWorker): Observable<void> {
    return this.httpClient.post<void>(this.getUrl('/CreateUser'), data);
  }

  public RemoveUser(data: IRemoveUserAccountWorker): Observable<void> {
    return this.httpClient.post<void>(this.getUrl('/RemoveUser'), data);
  }

}

